<div class="parent-guardian-info">
  <form *ngIf="submitter.matchingDupe" [action]="actionUrl" method="POST" #emailMatchForm>
    <input type="hidden" name="authenticity_token" [value]="csrfToken">
    <input type="hidden" name="user[login]" [value]="submitter.matchingDupe.found_user_uuid">
    <input type="hidden" name="user[user_duplicate_lookup_id]" [value]="submitter.matchingDupe.user_duplicate_lookup_id">
    <se-fe-alert seFeDataType="error">
      {{ submitter.matchingEmail }} is already in use on a SportsEngine account.
      <button seFeLink type="submit" (click)="emailMatchSignIn()">Sign in using this email</button>
    </se-fe-alert>
  </form>

  <div class="parent-guardian-info-icon">
    <se-fe-icon
      seFeDataName="spot_family"
      seFeDataSize="950"
      seFeDataAriaLabel="family">
    </se-fe-icon>
  </div>
  <div class="parent-guardian-info-title">
    <se-po-highlight-label
      label="Parent/Guardian Info"
      theme="adult">
    </se-po-highlight-label>
  </div>
  <div role="content" class="parent-guardian-info-content">
    <div *ngIf="!ready">
      <se-fe-spinner
        [seFeDataSize]="900"
        [seFeDataInverted]="false"
        [seFeDataCenter]="true"
      ></se-fe-spinner>
    </div>
    <form
      *ngIf="ready"
      [formGroup]="form"
      (ngSubmit)="submitter.validateAndSubmit(form, store)"
      novalidate>

      <section>
        <se-po-persona-info
          formControlName="accountInfo"
          [requiredFields]="['name', 'dateOfBirth']"
          [labels]="{
            name: 'Name',
            dateOfBirth: 'Birthday'
          }"
          [accountAgeRequired]="true"
        ></se-po-persona-info>
      </section>

      <section>
        <h3>
          Contact and Sign In Info
        </h3>

        <se-po-contact-info
          formControlName="contactInfo"
          showHelp="true"
          (init)="onContactInfoFormInit($event)"
        ></se-po-contact-info>
      </section>

      <div class="form-submit">
        <se-fe-button
          seFeDataEmphasis="high"
          seFeDataType="submit"
          [seFeDataIsLoading]="submitter.submitting"
          [seFeDataFullWidth]="true">Add Your Profile</se-fe-button>
      </div>

    </form>
  </div>
</div>
